module.exports = {
    COMPARATIVE_CIRCLE_CENTER_X: 110,
    COMPARATIVE_CIRCLE_RADIUS: 100,
    THRESHOLD_RATIO_LIMIT_BELOW_75: 0.75,
    THRESHOLD_RATIO_LIMIT_BELOW_100: 1
}